
<div id="alignment" :class="alignment">
  <view-linkable :content-element="contentElement" :entry="entry" :disabled="isInDetailViewEditMode">
    <blank-fallback :isBlank="isBlank(value)">
      <list-format-display v-if="shouldLinkify"
                           :class="isInDetailViewEditMode ? 'disabled-link' : 'btn-link'"
                           :href="value"
                           :is-list="displayAsList"
                           :value="value"
                           tag="a"
      />
      <list-format-display v-else :is-list="displayAsList" :value="value" tag="span" />

      <button v-if="propertyHasSecurityMaskToggle" @click="toggleSecurityMask" class="btn-icon" :class="securityMaskActive ? 'light-grey' : 'grey'">
        <span class="sr-only">{{securityMaskActive ? 'Show' : 'Hide'}} masked data</span>
        <icon :class="securityMaskActive ? 'hide' : 'show'"></icon>
      </button>
    </blank-fallback>
  </view-linkable>
</div>
